import { Card } from "../ui/card";
import { Tabs, TabsList, TabsTrigger } from "../ui/tabs";
import { PackageForm } from "./packages/PackageForm";
import { PackageListItem } from "./packages/PackageListItem";
import { usePackageManager } from "../../hooks/usePackageManager";

const CATEGORIES = [
  { key: "bodas", label: "Boda Fotografía" },
  { key: "foto_video", label: "Boda Foto + Video" },
  { key: "boda_civil", label: "Boda Civil" },
  { key: "xv", label: "XV Años" },
  { key: "content_creator", label: "Content Creator" },
  { key: "bautizo", label: "Bautizo" },
  { key: "sesion", label: "Sesiones de Fotos" },
  { key: "save_the_date", label: "Save the Date" },
  { key: "invitacion_digital", label: "Invitación Digital" },
  { key: "cabina_fotos", label: "Cabina de Fotos" },
  { key: "podcast_boda", label: "Podcast de tu Boda" },
];

export const AdminPackages = () => {
  const {
    category, changeCategory, categoryPackages, form, setForm, editingId, saving,
    startEdit, submit, removePackage, resetForm, dragReorder,
  } = usePackageManager();
  const { onDragStart, onDragOver, onDrop } = dragReorder;

  return (
    <Card className="p-6 space-y-6" data-testid="admin-packages-panel">
      <h3 className="font-semibold">Paquetes de servicios</h3>
      <p className="text-sm text-muted-foreground">
        Crea y edita paquetes por categoría. Se mostrarán automáticamente en el cotizador público.
      </p>

      <Tabs value={category} onValueChange={changeCategory}>
        <TabsList data-testid="admin-packages-category-tabs" className="flex-wrap h-auto">
          {CATEGORIES.map((c) => (
            <TabsTrigger key={c.key} value={c.key} data-testid={`admin-packages-tab-${c.key}`}>
              {c.label}
            </TabsTrigger>
          ))}
        </TabsList>
      </Tabs>

      <div className="space-y-2">
        {categoryPackages.length === 0 ? (
          <p data-testid="admin-packages-empty" className="text-sm text-muted-foreground">Aún no hay paquetes en esta categoría.</p>
        ) : (
          <>
            <p className="text-xs text-muted-foreground">Arrastra los paquetes para reordenarlos. El orden se refleja en el cotizador público.</p>
            {categoryPackages.map((pkg, idx) => (
              <PackageListItem
                key={pkg.id}
                pkg={pkg}
                onDragStart={() => onDragStart(idx)}
                onDragOver={onDragOver}
                onDrop={() => onDrop(idx)}
                onEdit={() => startEdit(pkg)}
                onDelete={() => removePackage(pkg.id)}
              />
            ))}
          </>
        )}
      </div>

      <PackageForm
        form={form}
        setForm={setForm}
        editingId={editingId}
        category={category}
        categoryLabel={CATEGORIES.find((c) => c.key === category)?.label}
        saving={saving}
        onSubmit={submit}
        onCancel={resetForm}
      />
    </Card>
  );
};
